import { render, staticRenderFns } from "./ChannelPartnerPage.vue?vue&type=template&id=799bdc29&"
import script from "./ChannelPartnerPage.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports